import { call, put, takeLatest } from 'redux-saga/effects';
import apiRequest from '@libs/apiRequest';
import { setSnack } from 'utilities/redux.actions';
import * as actionTypes from './redux.actionTypes';
import * as actions from './redux.actions';
import { API_ENDPOINTS } from './common';

// Fetch all menus
function* fetchMenusSaga() {
    try {
        const response = yield call(apiRequest, {
            url: API_ENDPOINTS.GET_ALL,
            method: 'GET'
        });

        yield put(actions.fetchMenusSuccess(response.data));
    } catch (error) {
        yield put(actions.fetchMenusFailure(error.message));
        yield put(setSnack({ message: 'Failed to fetch menus', type: 'error' }));
    }
}

// Fetch menu by ID
function* fetchMenuByIdSaga({ payload }) {
    try {
        const response = yield call(apiRequest, {
            url: API_ENDPOINTS.GET_BY_ID,
            method: 'GET',
            params: { menuId: payload.menuId }
        });

        yield put(actions.fetchMenuByIdSuccess(response.data));
    } catch (error) {
        yield put(actions.fetchMenuByIdFailure(error.message));
        yield put(setSnack({ message: 'Failed to fetch menu details', type: 'error' }));
    }
}

// Create menu
function* createMenuSaga({ payload }) {
    try {
        const response = yield call(apiRequest, {
            url: API_ENDPOINTS.CREATE,
            method: 'POST',
            data: JSON.stringify(payload)
        });

        yield put(actions.createMenuSuccess(response.data));
        yield put(actions.closeMenuDialog());
        yield put(setSnack({ message: 'Menu created successfully', type: 'success' }));
        // Refresh the menu list
        yield put(actions.fetchMenus());
    } catch (error) {
        const errorMessage = error?.response?.data?.message || error?.message || 'Failed to create menu';
        yield put(actions.createMenuFailure(errorMessage));
        yield put(setSnack({ message: errorMessage, type: 'error' }));
    }
}

// Update menu
function* updateMenuSaga({ payload }) {
    try {
        const response = yield call(apiRequest, {
            url: API_ENDPOINTS.UPDATE,
            method: 'POST',
            params: { menuId: payload.menuId },
            data: JSON.stringify(payload.data)
        });

        yield put(actions.updateMenuSuccess(response.data));
        yield put(actions.closeMenuDialog());
        yield put(setSnack({ message: 'Menu updated successfully', type: 'success' }));
        // Refresh the menu list
        yield put(actions.fetchMenus());
    } catch (error) {
        const errorMessage = error?.response?.data?.message || error?.message || 'Failed to update menu';
        yield put(actions.updateMenuFailure(errorMessage));
        yield put(setSnack({ message: errorMessage, type: 'error' }));
    }
}

// Delete menu
function* deleteMenuSaga({ payload }) {
    try {
        yield call(apiRequest, {
            url: API_ENDPOINTS.DELETE,
            method: 'DELETE',
            params: { menuId: payload.menuId }
        });

        yield put(actions.deleteMenuSuccess(payload.menuId));
        yield put(actions.closeDeleteDialog());
        yield put(setSnack({ message: 'Menu deleted successfully', type: 'success' }));
        // Refresh the menu list
        yield put(actions.fetchMenus());
    } catch (error) {
        const errorMessage = error?.response?.data?.message || error?.message || 'Failed to delete menu';
        yield put(actions.deleteMenuFailure(errorMessage));
        yield put(setSnack({ message: errorMessage, type: 'error' }));
    }
}

// Fetch permissions
function* fetchPermissionsSaga() {
    try {
        const response = yield call(apiRequest, {
            url: API_ENDPOINTS.GET_PERMISSIONS,
            method: 'GET'
        });

        yield put(actions.fetchPermissionsSuccess(response.data));
    } catch (error) {
        yield put(actions.fetchPermissionsFailure(error.message));
        yield put(setSnack({ message: 'Failed to fetch permissions', type: 'error' }));
    }
}

// Watcher saga
export default function* menuSaga() {
    yield takeLatest(actionTypes.FETCH_MENUS, fetchMenusSaga);
    yield takeLatest(actionTypes.FETCH_MENU_BY_ID, fetchMenuByIdSaga);
    yield takeLatest(actionTypes.CREATE_MENU, createMenuSaga);
    yield takeLatest(actionTypes.UPDATE_MENU, updateMenuSaga);
    yield takeLatest(actionTypes.DELETE_MENU, deleteMenuSaga);
    yield takeLatest(actionTypes.FETCH_PERMISSIONS, fetchPermissionsSaga);
}
